module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAcUlEQVR42u3QQRHAABACMexVUq3ULDVxP8LMCiBpm+WmzwMAAAAAAAAAAAAA0Cbf08vO9+Y2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYAhgNQAAAAAAAAAAAAAARvsBMELYZG+12/oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Ireland.png
// module id = 8s0l
// module chunks = 0 62 63